/* eslint-disable */
import { useState } from "react";
import { UserPlus, FileSpreadsheet } from "lucide-react";
import MembersList from "../members/MembersList";
import OnboardUserModal from "./OnboardUserModal";
import BulkOnboardModal from "./BulkOnboardModal";

export default function AdminDashboard({ canApprove = false }) {
  const [onboardOpen, setOnboardOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const reload = () => setReloadKey((k) => k + 1);

  return (
    <div>
      <div className="vsa-page-head">
        <div>
          <h1>Residents</h1>
          <p className="vsa-page-subtitle">All registered residents grouped by villa</p>
        </div>
        <div className="vsa-page-actions">
          <button
            className="vsa-onboard-btn vsa-onboard-btn-secondary"
            onClick={() => setBulkOpen(true)}
          >
            <FileSpreadsheet size={15} /> Bulk onboard
          </button>
          <button
            className="vsa-onboard-btn"
            onClick={() => setOnboardOpen(true)}
          >
            <UserPlus size={15} /> Onboard a member
          </button>
        </div>
      </div>
      <MembersList canApprove={canApprove} key={reloadKey} />

      <OnboardUserModal
        open={onboardOpen}
        onClose={() => setOnboardOpen(false)}
        onSuccess={reload}
      />
      <BulkOnboardModal
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        onSuccess={reload}
      />
    </div>
  );
}
